import { useMutation } from '@tanstack/react-query';

import { fetchWithCsrfTokenFormData } from 'utils/fetchWrapper';

export enum AssetType {
  COVER_PHOTO = 'cover_photo',
  COVER_LOGO = 'dark_logo',
  EMAIL_LOGO = 'light_logo',
}

interface IUpdateBrandingVariables {
  interviewUid: string;
  asset: Blob;
  name: string;
  type: string | AssetType;
}

interface IUpdateBrandingResponse {
  interview: string;
  name: string;
  cover_photo_url: string;
  dark_background_logo_url: string;
  light_background_logo_url: string;
  asset: Blob;
  type: string;
}

const useUpdateBranding = () => {
  const {
    mutateAsync: updateBranding,
    data,
    isLoading,
    error,
  } = useMutation<IUpdateBrandingResponse, Error, IUpdateBrandingVariables>(
    ['updateBranding'],
    async ({ interviewUid, asset, name, type }) => {
      const body = new FormData();
      body.append('interview', interviewUid);
      body.append('asset', asset);
      body.append('name', `${name}`);
      body.append('type', type);

      const response =
        await fetchWithCsrfTokenFormData<IUpdateBrandingResponse>(
          'builder/async/branding/update',
          'POST',
          body
        );

      return response;
    }
  );

  return {
    updateBranding,
    data,
    isLoading,
    error,
  };
};

export default useUpdateBranding;
